import styles from "@/styles/contact-us.module.scss"
import Head from "next/head"
import { useEffect, useState, useRef } from "react";
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import { getCookie } from '@/utils/cookie'
import IconLive from '@/svgs/icon-live.svg'
import IconCall from '@/svgs/icon-call.svg'
import IconEmail from '@/svgs/icon-email.svg'
import FollowiconFb from '@/svgs/share-icon/Followicon-fb.svg'
import FollowiconX from '@/svgs/share-icon/Followicon-x.svg'
import FollowiconPin from '@/svgs/share-icon/Followicon-pin.svg'
import FollowiconTiktop from '@/svgs/share-icon/Followicon-tt.svg'
import FollowiconIns from '@/svgs/share-icon/Followicon-ins.svg'
import FollowiconThreads from '@/svgs/share-icon/Followicon-threads.svg'

import ContactForm from "@/components/contact-us/ContactForm"
import Image from 'next/image'
import Link from 'next/link'

import contactApi from '@/service/modules/contactApi'

import getConfig from 'next/config'
import { DownOutlined } from "@ant-design/icons";
import { Button } from "antd";
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/bestdeals.co.nz',
    icon: FollowiconFb
  },
  {
    name: 'X (Twitter)',
    url: 'https://x.com/BestDealsCoNz',
    icon: FollowiconX
  },
  {
    name: 'Pinterest',
    url: 'https://au.pinterest.com/bestdealsconz/',
    icon: FollowiconPin
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/bestdealsnz/',
    icon: FollowiconIns
  },
  {
    name: 'Threads',
    url: 'https://www.threads.net/@bestdealsnz',
    icon: FollowiconThreads
  },
  {
    name: 'TikTok',
    url: 'https://www.tiktok.com/@bestdealsnz',
    icon: FollowiconTiktop
  }
]

export default function ContactUs() {

  const [highlightLiveChat, setHighlightLiveChat] = useState(false);
  const [showMoreContact, setShowMoreContact] = useState(true);
  const [highlightLoading, setHighlightLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false)
  const [affiliateId, setAffiliateId] = useState<string | null>(null);
  const [currentHour, setCurrentHour] = useState<number>(0);

  useEffect(() => {
    // Set current hour
    const hour = new Date().getHours();
    setCurrentHour(hour);

    // Get affiliateId from cookies
    const affiliateCookie = getCookie('affiliateid')
    if (affiliateCookie) {
      setAffiliateId(affiliateCookie || null);
    }

    if (localStorage.getItem('userEmail')) {
      setIsLogin(true)
    }
  }, []);

  useEffect(() => {
    // 获取Live chat是否需要优先展示
    getLiveChatStatus()
  }, []);

  // 获取Live chat是否需要优先展示
  const getLiveChatStatus = async () => {
    try {
      let res = await contactApi.getContactUsChat()
      if (res.data) {
        setHighlightLiveChat(res.data.isShow)

        if (!res.data.isShow) {
          setShowMoreContact(true)
        }
      }
    } catch (error) {
      setShowMoreContact(true)
      console.error(error)
    }
  }

  // 定义点击处理函数，放在组件顶层以便在多个地方使用
  const handleClick = () => {
    // 确保 Shadow Host 元素存在
    const chatBox = document.querySelector('#hello-jekka-chat-box');
    if (!chatBox?.shadowRoot) {
      console.error('Shadow root not found');
      return;
    }

    // 查找 Shadow DOM 中的按钮
    const shadowButton = chatBox.shadowRoot.querySelector('.chat-entry-button');
    if (shadowButton instanceof HTMLElement) {
      shadowButton.click(); // 触发点击
    } else {
      console.error('Chat button not found in shadow DOM');
    }
  };

  const checkHighlightBack = () => {
    const chatBox = document.querySelector('#hello-jekka-chat-box');
    const shadowButton = chatBox?.shadowRoot?.querySelector('.chat-entry-button');
    if(chatBox && shadowButton) {
      handleClick()
      setHighlightLoading(false)
    } else {
      !highlightLoading && setHighlightLoading(true)
      setTimeout(() => {
        checkHighlightBack()
      }, 100);
    }
  }

    // 监听highlightLiveChat状态变化，只有当它为true时才添加事件监听器
  // useEffect(() => {
  //   // 只有当highlightLiveChat为true时才添加事件监听器
  //   if (highlightLiveChat) {
  //     // 确保 #chatNow 元素已挂载
  //     const chatNowElement = chatNowRef.current;
  //     if (chatNowElement) {
  //       chatNowElement.addEventListener('click', handleClick);
  //     }

  //     return () => {
  //       if (chatNowElement) {
  //         setHighlightLoading(false)
  //         chatNowElement.removeEventListener('click', handleClick);
  //       }
  //     };
  //   }
  // }, [highlightLiveChat]); // 依赖highlightLiveChat，当它变化时重新执行

  return (
    <>
      <Head>
        <title>
          Online Shopping in New Zealand: Discount Store - BestDeals.co.nz
        </title>
        <meta
          name="keywords"
          content=""
        ></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout >
        <div className={`${styles['page-contact-us']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['content']}>
            <Image
              className={styles['banner']}
              src={`${imageDomain}/legal/contact-us-banner.png`}
              alt={'coupon-bg'}
              width={1152}
              height={200}
            ></Image>

            {
              highlightLiveChat ? (
                <div 
                  className={styles['online-live-chat-box']}
                  style={{ 
                    background: `url('${imageDomain}/legal/contact-us-livechat-bg.png') no-repeat`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    }}
                >
                  <div className={styles['chat-title']}>ONLINE LIVE CHAT WITH US</div>
                  <Button loading={highlightLoading} className={styles['chat-btn']} type="primary" id="chatNow" onClick={checkHighlightBack} >Chat With Us</Button>
                  <div className={styles['chat-desc']}>Real-time communication to quickly solve your problems</div>
                  <div className={styles['chat-time']}>Mondays to Fridays from <span style={{color: '#e6415f', fontWeight: 'bold'}}>{`11AM to 8PM (NZST)`}</span></div>
                </div>
              ) : null
            }

            <ul>
              <li>
                <br />
                <div style={{ fontWeight: 'bold' }}>Have a Question?</div>
                <br />
                <div>
                  You may find what you’re looking for in the FAQ page in our online{' '}
                  <Link href="/article/faq" legacyBehavior>
                    <a rel="noopener noreferrer" style={{ color: '#006dcc', textDecoration: 'underline' }}>
                      Help Centre!
                    </a>
                  </Link>
                </div>
                <br />
                <div>
                  <b>Email:</b> Send us an email and we’ll reply as soon as possible.
                </div>
                <div>
                  <b style={{ color: 'red' }}>· info@bestdeals.co.nz</b>
                </div>
                <br />
                <div>
                  Your inquiry is important to us and in most cases we are able to{' '}
                  <strong style={{ fontWeight: 'bold' }}>
                    respond within 24 to 36 business hours
                  </strong>
                  . However, if the enquiry is complex or requires additional information to be requested,
                  your inquiry and any number of other inquiries we may currently have may be extended to
                  up to 72 business hours for a response. Thanks for your support and consideration.
                </div>
                <br />
                <div>
                  <b>Phone:</b> Give us a call between the hours of 11am – 6pm (NZST) Monday to Friday.
                </div>
                <div>
                  <b style={{ color: 'red' }}>· 0 9883 0513</b>
                </div>
                <br />
                <br />
                <section className={styles['social-connect']} aria-labelledby="social-connect-title">
                  <div className={styles['social-connect-copy']}>
                    <span className={styles['social-connect-eyebrow']}>Stay connected</span>
                    <h2 id="social-connect-title">Follow Best Deals</h2>
                    <p>Discover new arrivals, special offers and a little everyday inspiration.</p>
                  </div>
                  <div className={styles['social-link-list']}>
                    {socialLinks.map((social) => (
                      <a
                        className={styles['social-link']}
                        href={social.url}
                        key={social.name}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Follow Best Deals on ${social.name} (opens in a new tab)`}
                      >
                        <span className={styles['social-icon']} aria-hidden="true">
                          <social.icon />
                        </span>
                        <span>{social.name}</span>
                      </a>
                    ))}
                  </div>
                </section>
                <br />
                <div>
                  <b>Alternatively</b> you can send us an enquiry using the form below:
                </div>
              </li>
            </ul>

            <div className={styles['answer-desc']}>
              Please Choose Subject of Your Enquiry: <span style={{ color: '#e60917' }}>*</span>
            </div>

            {
              showMoreContact ? (
                <>
                  <div className={`${styles['ask-title']} padding-top-20`}>
                    Contact Our Customer Service Department (<span style={{ color: '#e60917' }}>*</span> required)
                  </div>
                  <div className={styles['answer-desc']}>
                    Please Choose Subject of Your Enquiry: <span style={{ color: '#e60917' }}>*</span>
                  </div>
                  {
                    !isLogin
                    ?
                    <div className={styles['answer-desc']} style={{ fontWeight: '700' }}>
                      Please login ! <Link
                        href="/login?redirect=/contact-us"
                        legacyBehavior
                      >
                        <a className={styles['link']} style={{ fontWeight: "400" }} rel="noopener noreferrer">
                          click here
                        </a>
                      </Link>
                    </div>
                    :
                    null
                  }
                  <ContactForm></ContactForm>
                </>
              ) : (
                <div className={styles['more-contact-box']} onClick={() => setShowMoreContact(true) }>
                  More Contact Details
                  <DownOutlined style={{ marginLeft: '10px' }} />
                </div>
              )
            }

          </div>

        </div>
      </DefaultLayout>
    </>
  )
}
